<template>
  <!-- 实时供水量 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">实时供水量(m³)</span>
    </div>
    <div :id="id" class="main"></div>
  </div>
</template>

<script>

import chartResize from '@/mixin/chart-resize'
import { getUUID } from '../../../utils/util'
import moment from 'moment'


export default {
  mixins: [chartResize],
  name: 'WaterWorksSupply',
  components: {},
  data () {
    return {
      meritsArr: [],
      timer: {},
      id: getUUID(),
      myChart: null,
      color: [
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.5,
              color: 'rgba(115,215,255,0.70)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(4,224,239,0.00)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        },
        {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0.5,
              color: 'rgba(0,11,199,0.70)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(44,117,252,0)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      ],
      lineColor: ['#73A7FF', '#000BC7']
    }
  },

  created () {
    this.initMeritsArr()
  },
  beforeDestroy () {
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.queryData()
      this.getEchartData()
    })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    // 初始化标准时间
    initMeritsArr () {
      this.meritsArr = []
      let m = 0
      let h = 0
      // 标准
      for (let i = 0; i < 24; i++) {
        h = i * 1
        for (let j = 0; j < 12; j++) {
          m = j * 5
          this.meritsArr.push(moment().subtract(1, 'day').format('YYYY-MM-DD') + ' ' + h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0') + ':00')
        }
      }
    },
    getEchartData () {
      this.timer = setInterval(() => {
        this.queryData()
        // 你获取echarts数据的方法
      }, 1000 * 30)
    },
    queryData () {
      const params = {
        queryBeginTime: '2021-09-02 00:00:00',
        queryEndTime: '2021-09-03 00:00:00'
      }
      this.$http.get('/pipe-network/report/chart/report-total', { params }).then(res => {
        var series = []
        var xData = []
        // 临时解决昨天数据异常导致今天显示问题（288）
        // 大屏静态数据
        // res = WSData
        const timeobj = []
        if (res.data.length > 1) {
          this.meritsArr.forEach(item => {
            let num = 0
            res.data[1].timeSumDates.forEach(yday => {
              if (item === yday.time) {
                num = yday.cumulate
              }
            })
            // 进行数据填补
            const obj = {
              time: item,
              timeLabel: res.data[1].dateTime,
              cumulate: num,
              hLabel: item.substring(10, 16)
            }
            timeobj.push(obj)
          })
          res.data[1].timeSumDates = timeobj
        }

        for (let i = 0; i < res.data.length; i++) {
          const isTime = res.data[1].timeSumDates.length
          const dataS = res.data[i]
          const seriesData = []
          for (let j = 0; j < dataS.timeSumDates.length; j++) {
            seriesData.push(dataS.timeSumDates[j].cumulate)
            const tiemnum = dataS.timeSumDates[j].time.substring(10, 16)
            if (isTime !== 0 && i === 1) {
              xData.push(tiemnum)
            }
            if (isTime === 0 && i === 0) {
              xData.push(tiemnum)
            }
          }
          series.push({
            showAllSymbol: true,
            zlevel: -i,
            z: -i,
            name: dataS.dateTime,
            data: seriesData,
            symbol: 'none',
            type: 'line',
            smooth: true,
            areaStyle: {
              color: this.color[i]
            },
            lineStyle: {
              color: this.lineColor[i]
            }
          })
        }
        const data = {
          series: series,
          xData: xData
        }
        this.set(data)
      })
    },
    set (data) {
      this.myChart = echarts2.init(document.getElementById(this.id))

      var option
      option = {
        color: [
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0.5,
                color: 'rgba(115,215,255,0.70)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(4,224,239,0.00)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0.5,
                color: 'rgba(0,11,199,0.70)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(44,117,252,0)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        ],
        title: {
          subtext: 'm³',
          subtextStyle: {
            fontSize: '14px',
            color: '#98BDFF',
          },
          top: 20,
          left: 40,
        },
        legend: {
          left: 'right',
          top: 12,
          textStyle: {
            color: '#98BDFF',
          },
        },
        grid: [{ right: '1%', bottom: '5%', width: '98%', height: '80%', containLabel: true }],
        tooltip: {
          snap: true,
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderRadius: 4,
          borderWidth: 0,
          textStyle: {
            color: '#FFFFFF',
            fontSize: 14,
          },
        },
        // dataZoom: [
        //   // {
        //   //   show: false,
        //   //   realtime: true,
        //   //   type: 'slider',
        //   //   start: 0,
        //   //   end: 30,
        //   //   xAxisIndex: [0, 1],
        //   //   fillerColor: 'rgba(255, 255, 255, 0.1)', // 选中范围的填充颜色。
        //   //   //  backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色
        //   //   height: 18,
        //   //   handleSize: '80%',
        //   //   handleStyle: {
        //   //     borderWidth: 1
        //   //   },
        //   //   borderColor: 'rgba(255, 255, 255, 0.2)',
        //   //   showDataShadow: false, //是否显示数据阴影 默认auto
        //   //   showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
        //   //   filterMode: 'none',
        //   //   bottom: '4%'
        //   // },
        //   {
        //     type: 'inside'
        //   }
        // ],
        xAxis: [
          {
            type: 'category',
            // boundaryGap: true,
            // boundaryGap: false, // 距离坐标原点是否有间隙
            data: data.xData,
            // interval: 10,
            axisLabel: {
              // interval: 17, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
              textStyle: {
                color: '#98BDFF',
              },
            },
            splitLine: {
              // 改变竖向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#98BDFF',
              },
            },
            splitLine: {
              // 改变横向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid',
              },
            },
          },
        ],
        series: data.series,
      }
      console.log(option)
      this.myChart.clear()
      this.myChart.setOption(option)
    },
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 222px;
  width: 540px;
  background: url(~@/assets/myImg/h_9_ssgsl_box.png) no-repeat;
  background-size: cover;
  position: relative;

  .img-title {
    position: absolute;
    position: relative;
    // top: -18px;
    bottom: 18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }

  .btnBanner {
    position: absolute;
    top: 2px;
    left: 30px;
    right: 0;
    display: flex;

    .centerBtnClass {
      background: rgba(38, 72, 132, 0.25);
      border: 1px solid #337eae;
      border-radius: 4px;
      width: 50px;
      height: 22px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #00ebee;
      letter-spacing: 0;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
    }

    .outBtnClass {
      margin-left: 10px;
      background: rgba(38, 72, 132, 0.25);
      border: 1px solid #337eae;
      border-radius: 4px;
      width: 50px;
      height: 22px;
      font-family: MicrosoftYaHeiSemibold;
      font-size: 12px;
      color: #15a9f1;
      letter-spacing: 0;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
    }
  }

  .main {
    position: absolute;
    top: 10px;
    // float: left;
    height: 220px;
    width: 100%;
  }
}
</style>
